import { render, staticRenderFns } from "./ProblemEditor.vue?vue&type=template&id=56f4fed8&scoped=true&"
import script from "./ProblemEditor.vue?vue&type=script&lang=js&"
export * from "./ProblemEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProblemEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProblemEditor.vue?vue&type=style&index=1&id=56f4fed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f4fed8",
  null
  
)

component.options.__file = "ProblemEditor.vue"
export default component.exports